import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { IApplicationState } from '../../../types/redux';
import { TTypedThunkDispatch } from '../../../types/thunk';
import { getOffersData, getOffersCount } from '../../../actions/offersData';
import { updateTags } from '../../../actions/filterTags';
import { initJsonQuery } from '../../../actions/filters';
import {
  trackingActionPopupMoreParamOpen,
  trackingActionPopupMoreParamShowObjectsClick,
} from '../../../actions/analytics';
import { getPromoSearchTypes, selectOffersCount, selectOffersCountFetching } from '../../../selectors/filters';
import { getDiscountMortgageEnabled } from '../../../selectors/discountMortgage';
import { selectHasMetro } from '../../../selectors/currentRegion';
import { selectCanUseHiddenBase } from '../../../selectors/user';

import { MoreFiltersModalComponent } from './MoreFiltersModal';

export const MoreFiltersModal = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();

  const count = useSelector(selectOffersCount);
  const isCountFetching = useSelector(selectOffersCountFetching);
  const hasUndreground = useSelector(selectHasMetro);
  const canUseHiddenBase = useSelector(selectCanUseHiddenBase);
  const discountMortgageEnabled = useSelector(getDiscountMortgageEnabled);
  const promoSearchTypesLoaded = useSelector((state: IApplicationState) => Boolean(getPromoSearchTypes(state)));

  const handleUpdateTags = React.useCallback(() => {
    dispatch(updateTags());
  }, [dispatch]);

  const handleTrackingPopupMoreParamOpen = React.useCallback(() => {
    dispatch(trackingActionPopupMoreParamOpen());
  }, [dispatch]);

  const handleSubmit = React.useCallback(
    (canUseHiddenBase: boolean) => {
      dispatch(updateTags());
      dispatch(
        getOffersData({
          trackingAction: trackingActionPopupMoreParamShowObjectsClick,
          canUseHiddenBase,
        }),
      );
    },
    [dispatch],
  );

  const currentRegion = useSelector((state: IApplicationState) => state.jsonQuery?.region);

  const handleClearFilters = React.useCallback(() => {
    const newJsonQuery = {
      _type: 'newobjectsale' as const,
      engine_version: { type: 'term' as const, value: 2 },
      ...(currentRegion ? { region: currentRegion } : {}),
    };

    dispatch(initJsonQuery(newJsonQuery));
    dispatch(updateTags());
    dispatch(getOffersCount());
  }, [dispatch, currentRegion]);

  return (
    <MoreFiltersModalComponent
      count={count}
      isCountFetching={isCountFetching}
      hasUndreground={hasUndreground}
      canUseHiddenBase={canUseHiddenBase}
      discountMortgageEnabled={discountMortgageEnabled}
      promoSearchTypesLoaded={promoSearchTypesLoaded}
      updateTags={handleUpdateTags}
      trackingPopupMoreParamOpen={handleTrackingPopupMoreParamOpen}
      onSubmit={handleSubmit}
      onClearFilters={handleClearFilters}
    />
  );
};
